import { render, staticRenderFns } from "./Instructional.vue?vue&type=template&id=3d9c18c4&scoped=true"
import script from "./Instructional.vue?vue&type=script&lang=js"
export * from "./Instructional.vue?vue&type=script&lang=js"
import style0 from "./Instructional.vue?vue&type=style&index=0&id=3d9c18c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c18c4",
  null
  
)

export default component.exports